import axios from 'axios'
import { API_URL, RESTAURANT_SLUG } from '@/utils/environmentConfig'

// Erstelle eine Axios-Instanz für alle Services
export const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 10000 // 10 Sekunden Timeout
})

// Request-Interceptor zum Hinzufügen des Auth-Tokens
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // Multi-Tenant: Slug aus Build/Domain; nach Tisch-/Zimmer-Load ggf. Restaurant-ID
    if (RESTAURANT_SLUG) {
      config.headers['X-Restaurant-Slug'] = RESTAURANT_SLUG
    }
    const rid = typeof localStorage !== 'undefined' ? localStorage.getItem('current_restaurant_id') : null
    if (rid) {
      config.headers['X-Restaurant-Id'] = rid
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response-Interceptor: Bei abgelaufener Session (410) im Kundenbereich Session löschen und zur Tisch-URL umleiten
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const code = error.response?.data?.code
    const path = typeof window !== 'undefined' ? window.location.pathname : ''
    const isCustomerPath = /^\/(table|menu|cart|order-status)/.test(path)

    if (status === 410 && code === 'session_expired' && isCustomerPath) {
      const tableBaseUrl = localStorage.getItem('tableBaseUrl')
      localStorage.removeItem('sessionNumericId')
      localStorage.removeItem('sessionUniqueId')
      localStorage.removeItem('sessionId')
      localStorage.removeItem('orderType')
      localStorage.removeItem('tableId')
      if (tableBaseUrl) {
        window.location.href = tableBaseUrl + '?session_expired=1'
      }
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
) 